import {
  FETCH_TRANS_PENDING,
  FETCH_TRANS_REJECTED,
  FETCH_TRANS_FULFILLED,
  ENABLE_DROP_MODE,
  DROP_ITEM,
  POST_SAVE_TEAM,
  POST_LOGIN,
  GET_My11_LOGIN,
  POST_My11_LOGOUT,
  POST_SAVE_BRACKET,
  CHANGE_MODE,
  RESET_TEAM,
  SHOW_HIDE_POPUP,
  CHANGE_FORMATION,
  AFTER_CHANGE_FORMATION,
  FETCH_FIXTURES,
  FETCH_CONSTRAINTS,
  CREATE_EMPTY_TEAM_BY_FORMATION,
  FETCH_PLAYERS,
  FETCH_USER_TEAM,
  CHANGE_SKILL_TAB,
  ADD_PLAYER,
  REMOVE_PLAYER,
  SHOW_HIDE_PLAYERLISTING,
  ADD_REMOVED_PLAYER_FROM_FORMATION,
  REMOVE_REMOVED_PLAYER_FROM_FORMATION,
  ADD_PLAYER_FOR_CARD,
  REMOVE_PLAYER_FOR_CARD,
  FETCH_PLAYER_CARD,
  POST_GDPR,
  FETCH_REVEALED_TEAM,
  SHOW_HIDE_OVERLAY,
  CHANGE_FILTER_TAB,
  CHANGE_FILTER_TAB_CHECKES,
  APPLY_FILTER,
  RESET_FILTER,
  CLOSE_FILTER,
  CHANGE_SORT_BY,
  CHANGE_SKILL_TAB_AFTER_PLAYER_SELECTION,
  CLEAR_PLAYER_SEARCH_ID,
  CHANGE_PLAYER_CARD_TAB,
  FETCH_PLAYER_STATS,
  ADD_REMOVE_PLAYER,
  SELECT_C_VC,
  CHANGE_SORT_BY_TEAM,
  FETCH_FAV_TEAM,
  FETCH_PUBLIC_CONTEST,
  FETCH_PRIVATE_CONTEST,
  POST_CREATE_CONTEST,
  POST_JOIN_CONTEST,
  FETCH_CONTEST_LEADERBOARD,
  FETCH_GLOBAL_LEADERBOARD,
  FETCH_GLOBAL_LIVE_RANK,
  FETCH_FAVTEAM_LEADERBOARD,
  FETCH_FAVTEAM_LIVE_RANK,
  FETCH_CONTEST_NEWJOINEE,
  FETCH_TEAM_COMPARISON,
  SET_LAST_UPDATED_TIME,
  RESET_CONTEST_LEADERBOARD_DATA,
  CHANGE_SELECTED_FIXTURE,
  FETCH_USER_PLAYED_GAMEDAYS,
  POST_TRANSFER_TEAM,
  POST_CAPTAIN_TEAM,
  FETCH_TRANSFER_HISTORY,
  FETCH_TRANSFER_HISTORY_PLAYERS,
  FETCH_PLAYERS_STATS,
  CONTEST_APPLY_FILTER,
  CONTEST_CLOSE_FILTER,
  CONTEST_RESET_FILTER,
  CONTEST_CHANGE_FILTER_TAB_CHECKES,
  CONTEST_CHANGE_FILTER_TAB,
  FETCH_USER_TEAM_LIST,
  CHANGE_SELECTED_TEAM,
  FETCH_PLAYERS_LIVE,
  FETCH_OTHER_USER_TEAM,
  UPCOMING_FIXTURE,
  FETCH_GAMERCARD,
  FETCH_MIX,
  FETCH_WIDGET,
  IS_SHOW_MENU,
  IS_HEADER_DATA,
  FETCH_USER_STATS_PLAYER,
  CHANGE_BOOSTER,
  FETCH_BOOSTERS_CONTRAINTS,
  FETCH_BADGES,
  POST_REMOVE_LEAGUE,
  CHANGE_REMOVE_PLAYER,
  FETCH_USER_BADGES,
  SET_WRAPPER,
  POST_SAVE_BADGE_NOTIFY,
  UPDATE_USER_BADGES,
  UPDATE_UNLOCKED_BADGES,
  UPDATE_UNLOCKED_BADGES_TEAM,
  RESET_STORE,
  FETCH_USER_BADGES_AFTER_POINT_CAL,
  SHOW_HIDE_PULLTO_REFRESH,
  AKAMAI_TIMER_CALL,
  POST_TEAM_NAME_SUBMIT,
  FETCH_CTR_FAV_DATA,
  FETCH_PROFILE_DATA,
  POST_PROFILE_UPDATE_SUBMIT,
  SHOULD_DELETE_BOOSTER,
  FETCH_CAPTAIN_LEADERBOARD,
  FETCH_CAPTAIN_LIVE_RANK,
  FETCH_VICE_CAPTAIN_LEADERBOARD,
  FETCH_VICE_CAPTAIN_LIVE_RANK,
  FETCH_KNOCKOUT_LEADERBOARD,
  FETCH_KNOCKOUT_LIVE_RANK,
  FETCH_CONFIG_DATA,
  FETCH_USER_POINTS_HISTORY,
  GET_MY_RANK,
  VIEW_TEAM,
  BOOSTER_RESET,
} from "./../../actionTypes";
import {
  transAPI,
  constraintsAPI,
  fixturesAPI,
  postUserTeamAPI,
  playersAPI,
  getUserTeamUrl,
  playersCardAPI,
  postLoginAPI,
  getMy11Login,
  postMy11Logout,
  gdprCookieAPI,
  getRevealedTeamUrl,
  playerStatsAPI,
  favTeamAPI,
  getPublicContest,
  getLivePublicContest,
  getPrivateContest,
  getLivePrivateContest,
  postCreateContest,
  postJoinContest,
  getContestLeaderboard,
  getLiveContestLeaderboard,
  getGlobalLeaderboard,
  getLiveGlobalRank,
  getLiveGlobalLeaderboard,
  getFavTeamLeaderboard,
  getLiveFavTeamRank,
  getLiveFavTeamLeaderboard,
  getContestNewJoinee,
  getComparisonData,
  userPlayedGamedaysAPI,
  postTransferTeamAPI,
  postCaptainTeamAPI,
  transferHistoryAPI,
  transferHistoryPlayersAPI,
  playerStatisticsAPI,
  getMyTeamListAPI,
  getOtherUserTeamUrl,
  gamerCardAPI,
  getMyTeamListOverallAPI,
  mixAPI,
  widgetAPI,
  userStatsAPI,
  playersCardLiveAPI,
  playerStatsLiveAPI,
  playerStatisticsLiveAPI,
  widgetLiveAPI,
  boostersConAPI,
  BadgesAPI,
  removeLeagueAPI,
  leaveLeagueAPI,
  UserBadgesAPI,
  postBadgeNotifyAPI,
  userbadgemasterAPI,
  akamaiTimeURL,
  teamNamePostApi,
  countryFavStatic,
  profileGetApi,
  profileUpdatePostApi,
  getLiveCaptainRank,
  getLiveViceCaptainRank,
  getLiveKnockoutRank,
  configApi,
  userPtsHistory,
  postMy11ExtLogout,
} from "./../../apiUrls";
import objUrl from "./../../apiUrls";
import config from "./../../../common/config";
import core from "./../../../common/core";
import app from "./../../../common/app";
import Axios from "axios";

/** START API */
////////////////get//////////////////////
export function transFetchData() {
  let transVersion = 1;
  let apiUrl = transAPI;
  if (window.transVersion) {
    transVersion = window.transVersion;
  }
  apiUrl = apiUrl.replace("{{lang}}", config.CURRENT_LANGUAGE);
  apiUrl = apiUrl.replace("{{transVersion}}", transVersion);

  const params = {
    url: apiUrl,
    params: {},
  };
  return { type: "FETCH_TRANS", payload: core.makeAPICall(params) };
}
export function playersFetchData(payload) {
  const {
    tourgamedayId,
    teamgamedayId,
    isNotShowLoader,
    isLive,
    LivePntsVrsnNo,
    AnnouncedVersion,
  } = payload;
  // let sPlayersAPI = playersAPI.replace('{{lang}}', config.CURRENT_LANGUAGE);
  // if (isLive) {
  //     sPlayersAPI= sPlayersAPI.replace('{{live}}', '/live');
  // }
  // else {
  //     sPlayersAPI= sPlayersAPI.replace('{{live}}', '');
  // }
  let params = {
    url: objUrl.playersAPI, //sPlayersAPI,
    loader: !isNotShowLoader,
    params: {
      lang: config.CURRENT_LANGUAGE,
      tourgamedayId: tourgamedayId,
      teamgamedayId: teamgamedayId,
    },
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  if (AnnouncedVersion) {
    params.params.announcedVersion = AnnouncedVersion;
  }
  return { type: FETCH_PLAYERS, payload: core.makeAPICall(params) };
}
export function constraintsFetchData(payload) {
  let sAPI = constraintsAPI.replace("{{gameDayId}}", payload.gameDayId);
  sAPI = sAPI.replace("{{tourId}}", payload.tourId);
  const params = {
    url: sAPI,
    params: {
      gamedayId: payload.gameDayId,
    },
  };
  return { type: FETCH_CONSTRAINTS, payload: core.makeAPICall(params) };
}

export function fixturesFetchData(payload) {
  const { VersionMaster } = payload;
  let params = {
    url: fixturesAPI,
    params: {
      lang: config.CURRENT_LANGUAGE,
    },
  };
  if (VersionMaster) {
    params.params.liveVersion = VersionMaster;
  }
  return { type: FETCH_FIXTURES, payload: core.makeAPICall(params) };
}
export function userTeamFetchData(payload) {
  const { gamedayId, tourgamedayId, PhaseId, jMaxTeamPlayers } = payload;
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sUrl = objUrl.getUserTeamUrl.replace("{{guid}}", guid);
  const params = {
    url: sUrl, //getUserTeamUrl.replace('{{guid}}', guid),
    params: {
      optType: 1,
      gamedayId: gamedayId,
      tourgamedayId: tourgamedayId,
      phaseId: PhaseId,
    },
  };
  return {
    type: FETCH_USER_TEAM,
    payload: core.makeAPICall(params),
    meta: { jMaxTeamPlayers: jMaxTeamPlayers },
  };
}
export function userOtherTeamFetchData(payload) {
  const { gamedayId, tourgamedayId, PhaseId, teamId, userId } = payload;
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sUrl = objUrl.getOtherUserTeamUrl.replace("{{guid}}", guid);
  const params = {
    url: sUrl, //getOtherUserTeamUrl.replace('{{guid}}', guid),
    params: {
      optType: 1,
      gamedayId: gamedayId,
      tourgamedayId: tourgamedayId,
      phaseId: PhaseId,
      teamId: teamId,
      socialId: userId,
    },
  };
  return { type: FETCH_USER_TEAM, payload: core.makeAPICall(params) };
}
export function revealedTeamFetchData() {
  const params = {
    url: getRevealedTeamUrl,
    params: {},
  };
  return { type: FETCH_REVEALED_TEAM, payload: core.makeAPICall(params) };
}
export function playerCardFetchData(payload) {
  const { LivePntsVrsnNo } = payload;
  const sUrl = objUrl.playersCardAPI
    .replace("{{Id}}", payload)
    .replace("{{lang}}", config.CURRENT_LANGUAGE);
  let params = {
    url: sUrl,
    params: {},
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return { type: FETCH_PLAYER_CARD, payload: core.makeAPICall(params) };
}
export function playersLiveFetchData(payload) {
  const {
    tourgamedayId,
    teamgamedayId,
    isNotShowLoader,
    isUpdateOriginal,
    isLive,
    LivePntsVrsnNo,
    AnnouncedVersion,
  } = payload;
  // let sPlayersAPI = playersAPI.replace('{{lang}}', config.CURRENT_LANGUAGE);
  // if (isLive) {
  //     sPlayersAPI= sPlayersAPI.replace('{{live}}', '/live');
  // }
  // else {
  //     sPlayersAPI= sPlayersAPI.replace('{{live}}', '');
  // }
  let params = {
    url: objUrl.playersAPI, //sPlayersAPI,
    loader: !isNotShowLoader,
    params: {
      lang: config.CURRENT_LANGUAGE,
      tourgamedayId: tourgamedayId,
      teamgamedayId: teamgamedayId,
    },
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  if (AnnouncedVersion) {
    params.params.announcedVersion = AnnouncedVersion;
  }
  return {
    type: FETCH_PLAYERS_LIVE,
    payload: core.makeAPICall(params),
    meta: { isUpdateOriginal: isUpdateOriginal },
  };
}
export function mixFetchData(payload) {
  const { isNotShowLoader } = payload;
  const params = {
    url: mixAPI,
    loader: !isNotShowLoader,
    params: {
      lang: config.CURRENT_LANGUAGE,
    },
  };
  return { type: FETCH_MIX, payload: core.makeAPICall(params) };
}
////////////////get//////////////////////

////////////////post/////////////////////
export function saveTeam(payload) {
  const params = {
    url: postUserTeamAPI.replace("{{guid}}", payload.GUID),
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_SAVE_TEAM, payload: core.makeAPICall(params) };
}
export function loginPost(payload) {
  const params = {
    url: postLoginAPI,
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_LOGIN, payload: core.makeAPICall(params) };
}
// export function getMy11LoginDetails(payload) {
//   const params = {
//     url: getMy11Login,
//     method: "POST",
//     data: payload,
//   };
//   return { type: GET_My11_LOGIN, payload: core.makeAPICall(params) };
// }

export function getMy11LoginDetails(payload) {
  const params = {
    url: getMy11Login,
    method: "POST",
    data: payload,
  };
  return { type: GET_My11_LOGIN, payload: core.makeAPICall(params) };
}

export function postApiMy11Logout() {
  const uid = core.getCookie(config.COOKIE_UID);
  const authToken = core.getCookie(config.COOKIE_AUTHTOKEN);
  const params = {
    url: postMy11Logout,
    method: "POST",
    // data: {
    //   query: "mutation logoutMutation { logout { successful }}",
    //   variables: {},
    // },
    data: {
      userId: uid,
      token: authToken,
    },
  };
  return { type: POST_My11_LOGOUT, payload: core.makeAPICall(params) };
}
export function postApiMy11ExtLogout() {
  const uid = core.getCookie(config.COOKIE_UID);
  const authToken = core.getCookie(config.COOKIE_AUTHTOKEN);
  const params = {
    url: postMy11ExtLogout,
    method: "POST",

    data: {
      // userId: uid,
      // token: authToken,
    },
  };
  return { type: POST_My11_LOGOUT, payload: core.makeAPICall(params) };
}
export function gdprPost() {
  const params = {
    url: gdprCookieAPI,
    method: "POST",
    params: {},
    //data: payload
  };
  return { type: POST_GDPR, payload: core.makeAPICall(params) };
}
export function transferTeam(payload) {
  const params = {
    url: postTransferTeamAPI.replace("{{guid}}", payload.GUID),
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_TRANSFER_TEAM, payload: core.makeAPICall(params) };
}
export function captainUpdate(payload) {
  const params = {
    url: postCaptainTeamAPI.replace("{{guid}}", payload.GUID),
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_CAPTAIN_TEAM, payload: core.makeAPICall(params) };
}
////////////////post/////////////////////
/** END API */

export function enableDropMode(payload) {
  return {
    type: ENABLE_DROP_MODE,
    payload: payload,
  };
}
export function applyMode(payload) {
  return {
    type: APPLY_FILTER,
    payload: payload,
  };
}
export function resetMode() {
  return {
    type: RESET_FILTER,
  };
}
export function closeMode() {
  return {
    type: CLOSE_FILTER,
  };
}
export function changeSortBy(payload) {
  return {
    type: CHANGE_SORT_BY,
    payload: payload,
  };
}

export function getMyRank(payload) {
  return {
    type: GET_MY_RANK,
    payload: payload,
  };
}
export function viewMyTeam(payload) {
  return {
    type: VIEW_TEAM,
    payload: payload,
  };
}

export function showHidePopup(payload) {
  return {
    type: SHOW_HIDE_POPUP,
    payload: payload,
  };
}

export function changeFormation(payload) {
  return {
    type: CHANGE_FORMATION,
    payload: payload,
  };
}
export function creteEmptyTeamByFormation(payload) {
  return {
    type: CREATE_EMPTY_TEAM_BY_FORMATION,
    payload: payload,
  };
}
export function afterChangeFormation(payload) {
  return {
    type: AFTER_CHANGE_FORMATION,
    payload: payload,
  };
}
export function changeSkillTab(payload) {
  return {
    type: CHANGE_SKILL_TAB,
    payload: payload,
  };
}
export function changeSkillTabAfterPlayerSelection(payload) {
  return {
    type: CHANGE_SKILL_TAB_AFTER_PLAYER_SELECTION,
    payload: payload,
  };
}
export function clearSearchId() {
  return {
    type: CLEAR_PLAYER_SEARCH_ID,
  };
}
export function changeFilterTab(payload) {
  return {
    type: CHANGE_FILTER_TAB,
    payload: payload,
  };
}
export function changeFilterTabChecks(payload) {
  return {
    type: CHANGE_FILTER_TAB_CHECKES,
    payload: payload,
  };
}
export function addPlayer(payload) {
  return {
    type: ADD_PLAYER,
    payload: payload,
  };
}

export function removePlayer(payload) {
  return {
    type: REMOVE_PLAYER,
    payload: payload,
  };
}
export function showHidePlayerListing(payload) {
  return {
    type: SHOW_HIDE_PLAYERLISTING,
    payload: payload,
  };
}
export function addRemovedPlayerFromFormation(payload) {
  return {
    type: ADD_REMOVED_PLAYER_FROM_FORMATION,
    payload: payload,
  };
}
export function removeRemovedPlayerFromFormation(payload) {
  return {
    type: REMOVE_REMOVED_PLAYER_FROM_FORMATION,
    payload: payload,
  };
}
export function addPlayerForCard(payload) {
  return {
    type: ADD_PLAYER_FOR_CARD,
    payload: payload,
  };
}
export function removePlayerForCard(payload) {
  return {
    type: REMOVE_PLAYER_FOR_CARD,
    payload: payload,
  };
}

export function playerCardFetch(payload) {
  const { LivePntsVrsnNo, VersionMaster } = payload;
  let url = objUrl.playersCardAPI.replace("{{tour_id}}", payload.tourID);
  url = url.replace("{{team_id}}", payload.teamId);
  url = url.replace("{{player_id}}", payload.playerId);
  let params = {
    url: url,
    params: {},
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  if (VersionMaster) {
    params.params.buster = VersionMaster;
  }
  return { type: FETCH_PLAYER_CARD, payload: core.makeAPICall(params) };
}
export function showHideOverlay(payload) {
  return {
    type: SHOW_HIDE_OVERLAY,
    payload: payload,
  };
}
export function changePlayerCardTab(payload) {
  return {
    type: CHANGE_PLAYER_CARD_TAB,
    payload: payload,
  };
}
export function playerStatsFetch(payload) {
  const { LivePntsVrsnNo } = payload;
  let url = objUrl.playerStatsAPI.replace("{{team_id}}", payload.teamId);
  url = url.replace("{{player_id}}", payload.playerId);
  url = url.replace("{{gameday_id}}", payload.gamedayId);
  let params = {
    url: url,
    params: {},
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return { type: FETCH_PLAYER_STATS, payload: core.makeAPICall(params) };
}
export function addRemovePlayer(payload) {
  return {
    type: ADD_REMOVE_PLAYER,
    payload: payload,
  };
}
export function selectCAndVc(payload) {
  return {
    type: SELECT_C_VC,
    payload: payload,
  };
}
export function changeSortByTeam(payload) {
  return {
    type: CHANGE_SORT_BY_TEAM,
    payload: payload,
  };
}

export function fetchFavTeam(payload) {
  let url = favTeamAPI.replace("{{tour_id}}", payload.tourID);
  url = url.replace("{{lang}}", config.CURRENT_LANGUAGE);
  const params = {
    url: url,
  };
  return { type: FETCH_FAV_TEAM, payload: core.makeAPICall(params) };
}

/* get public contest */
export function publicContestFetchData(payload) {
  const { LivePntsVrsnNo, isLive } = payload;
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let apiName = objUrl.getPublicContest; //isLive ? getLivePublicContest : getPublicContest;
  let params = {
    url: apiName.replace("{{guid}}", guid),
    params: {
      pageNo: 1,
      records: 5,
    },
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return { type: FETCH_PUBLIC_CONTEST, payload: core.makeAPICall(params) };
}

/* get private contest */
export function privateContestFetchData(payload) {
  const { LivePntsVrsnNo, isLive } = payload;
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let apiName = objUrl.getPrivateContest; //isLive ? getLivePrivateContest : getPrivateContest;
  let params = {
    url: apiName.replace("{{guid}}", guid),
    params: {
      pageNo: 1,
      records: 50,
    },
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return { type: FETCH_PRIVATE_CONTEST, payload: core.makeAPICall(params) };
}

/* Create contest */
export function createContestPostData(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const param = {
    url: postCreateContest.replace("{{guid}}", guid),
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_CREATE_CONTEST, payload: core.makeAPICall(param) };
}

/* Join contest */
export function joinContestPostData(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const param = {
    url: postJoinContest.replace("{{guid}}", guid),
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_JOIN_CONTEST, payload: core.makeAPICall(param) };
}

/* get contest leaderboard */
export function contestLeaderboardFetchData(obj, data, isLive, cancelToken) {
  const objCookie = app.getLoginCookie();
  // let guid = objCookie ? objCookie.GUID : '0';
  let contestId = obj.legid;
  let apiName = objUrl.getContestLeaderboard; //isLive ? getLiveContestLeaderboard : getContestLeaderboard;
  let params = {
    url: apiName.replace("{{contestId}}", contestId),
    params: data,
  };
  if (data && data.pageNo && data.pageNo > 1) {
    params["loader"] = false;
  }
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  return {
    type: FETCH_CONTEST_LEADERBOARD,
    meta: { leagueObj: obj, cookie: objCookie, isLive: isLive },
    payload: core.makeAPICall(params),
  };
}

/* get global leaderboard */
export function globalLeaderboardFetchData(obj, data, isLive, cancelToken) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let apiName = objUrl.getGlobalLeaderboard; //isLive ? getLiveGlobalLeaderboard : getGlobalLeaderboard;
  let params = {
    url: apiName.replace("{{guid}}", guid),
    params: data,
  };
  if (data && data.pageNo && data.pageNo > 1) {
    params["loader"] = false;
  }
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  return {
    type: FETCH_GLOBAL_LEADERBOARD,
    meta: { leagueObj: obj, cookie: objCookie, isLive: isLive },
    payload: core.makeAPICall(params),
  };
}

/* get global leaderboard rank */
export function globalRankFetchData(obj) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const params = {
    url: getLiveGlobalRank.replace("{{guid}}", guid),
    params: {
      optType: 1,
      pageNo: 1,
      topNo: 1,
    },
  };
  return {
    type: FETCH_GLOBAL_LIVE_RANK,
    meta: { leagueObj: obj },
    payload: core.makeAPICall(params),
  };
}

/* get favourite team leaderboard */
export function favTeamLeaderboardFetchData(obj, data, isLive, cancelToken) {
  const objCookie = app.getLoginCookie();
  // let guid = objCookie ? objCookie.GUID : '0';
  let favTeamId = objCookie && objCookie.FavTeamId ? objCookie.FavTeamId : "0";
  let apiName = isLive ? getLiveFavTeamLeaderboard : getFavTeamLeaderboard;
  let params = {
    url: apiName.replace("{{favteamid}}", favTeamId),
    params: data,
  };
  if (data && data.pageNo && data.pageNo > 1) {
    params["loader"] = false;
  }
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  return {
    type: FETCH_FAVTEAM_LEADERBOARD,
    meta: { leagueObj: obj, cookie: objCookie, isLive: isLive },
    payload: core.makeAPICall(params),
  };
}

/* get favourite team leaderboard rank */
export function favTeamRankFetchData(obj) {
  const objCookie = app.getLoginCookie();
  // let favTeamId = (objCookie && objCookie.FavTeamId) ? objCookie.FavTeamId : '0';
  let guid = objCookie ? objCookie.GUID : "0";
  const params = {
    url: getLiveFavTeamRank.replace("{{guid}}", guid),
    params: {
      optType: 1,
      pageNo: 1,
      topNo: 1,
    },
  };
  return {
    type: FETCH_FAVTEAM_LIVE_RANK,
    meta: { leagueObj: obj },
    payload: core.makeAPICall(params),
  };
}

/* get captain leaderboard */
export function captainLeaderboardFetchData(obj, data, isLive, cancelToken) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let apiName = objUrl.getCaptainLeaderboard; //isLive ? getLiveGlobalLeaderboard : getGlobalLeaderboard;
  let params = {
    url: apiName.replace("{{guid}}", guid),
    params: data,
  };
  if (data && data.pageNo && data.pageNo > 1) {
    params["loader"] = false;
  }
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  return {
    type: FETCH_CAPTAIN_LEADERBOARD,
    meta: { leagueObj: obj, cookie: objCookie, isLive: isLive },
    payload: core.makeAPICall(params),
  };
}

/* get captain leaderboard rank */
export function captainRankFetchData(obj) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const params = {
    url: getLiveCaptainRank.replace("{{guid}}", guid),
    params: {
      optType: 1,
      pageNo: 1,
      topNo: 1,
    },
  };
  return {
    type: FETCH_CAPTAIN_LIVE_RANK,
    meta: { leagueObj: obj },
    payload: core.makeAPICall(params),
  };
}

/* get vice captain leaderboard */
export function viceCaptainLeaderboardFetchData(
  obj,
  data,
  isLive,
  cancelToken
) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let apiName = objUrl.getViceCaptainLeaderboard; //isLive ? getLiveGlobalLeaderboard : getGlobalLeaderboard;
  let params = {
    url: apiName.replace("{{guid}}", guid),
    params: data,
  };
  if (data && data.pageNo && data.pageNo > 1) {
    params["loader"] = false;
  }
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  return {
    type: FETCH_VICE_CAPTAIN_LEADERBOARD,
    meta: { leagueObj: obj, cookie: objCookie, isLive: isLive },
    payload: core.makeAPICall(params),
  };
}

/* get vice captain leaderboard rank */
export function viceCaptainRankFetchData(obj) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const params = {
    url: getLiveViceCaptainRank.replace("{{guid}}", guid),
    params: {
      optType: 1,
      pageNo: 1,
      topNo: 1,
    },
  };
  return {
    type: FETCH_VICE_CAPTAIN_LIVE_RANK,
    meta: { leagueObj: obj },
    payload: core.makeAPICall(params),
  };
}

export function knockoutLeaderboardFetchData(obj, data, isLive, cancelToken) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let apiName = objUrl.getKnockoutLeaderboard; //isLive ? getLiveGlobalLeaderboard : getGlobalLeaderboard;
  let params = {
    url: apiName.replace("{{guid}}", guid),
    params: data,
  };
  if (data && data.pageNo && data.pageNo > 1) {
    params["loader"] = false;
  }
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  return {
    type: FETCH_KNOCKOUT_LEADERBOARD,
    meta: { leagueObj: obj, cookie: objCookie, isLive: isLive },
    payload: core.makeAPICall(params),
  };
}

/* get knockout leaderboard rank */
export function knockoutRankFetchData(obj) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const params = {
    url: getLiveKnockoutRank.replace("{{guid}}", guid),
    params: {
      optType: 1,
      pageNo: 1,
      topNo: 1,
    },
  };
  return {
    type: FETCH_KNOCKOUT_LIVE_RANK,
    meta: { leagueObj: obj },
    payload: core.makeAPICall(params),
  };
}

/* get contest new joinee */
export function contestNewJoineeFetchData(obj, data) {
  const objCookie = app.getLoginCookie();
  // let guid = objCookie ? objCookie.GUID : '0';
  let contestId = obj.legid;
  const params = {
    url: getContestNewJoinee.replace("{{contestId}}", contestId),
    params: data,
  };
  return {
    type: FETCH_CONTEST_NEWJOINEE,
    meta: { leagueObj: obj, cookie: objCookie },
    payload: core.makeAPICall(params),
  };
}

/* get team comparison */
export function getTeamComparison(data) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const params = {
    url: getComparisonData.replace("{{guid}}", guid),
    params: data,
  };
  return { type: FETCH_TEAM_COMPARISON, payload: core.makeAPICall(params) };
}

/* get server time */
export function setLastUpdatedTime(timespan) {
  return { type: SET_LAST_UPDATED_TIME, meta: { timespan: timespan } };
}

export function resetContestLeaderboardData() {
  return {
    type: RESET_CONTEST_LEADERBOARD_DATA,
  };
}

export function getUserPlayedGameDays() {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = userPlayedGamedaysAPI.replace("{{guid}}", guid);
  const params = {
    url: sUrl,
    params: {
      optType: 1,
    },
  };
  return {
    type: FETCH_USER_PLAYED_GAMEDAYS,
    payload: core.makeAPICall(params),
  };
}
export function changeSelectedFixture(payload) {
  return {
    type: CHANGE_SELECTED_FIXTURE,
    payload: payload,
  };
}

export function getTransferHistory() {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  const sUrl = transferHistoryAPI.replace("{{guid}}", guid);
  const params = {
    url: sUrl,
  };

  return { type: FETCH_TRANSFER_HISTORY, payload: core.makeAPICall(params) };
}

export function getTransferHistoryPlayers(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sUrl = transferHistoryPlayersAPI.replace("{{guid}}", guid);
  sUrl = sUrl.replace("{{gamedayId}}", payload.gamedayId);
  const params = {
    url: sUrl,
  };

  return {
    type: FETCH_TRANSFER_HISTORY_PLAYERS,
    payload: core.makeAPICall(params),
  };
}

export function resetTeam() {
  return {
    type: RESET_TEAM,
  };
}

export function getPlayerStatistics(payload) {
  const { isLive, LivePntsVrsnNo } = payload;
  let sUrl = playerStatisticsAPI;
  let sLiveUrl = playerStatisticsLiveAPI;
  let apiName = objUrl.playerStatisticsAPI; //isLive ? sLiveUrl : sUrl;
  let params = {
    url: apiName,
    params: {},
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return { type: FETCH_PLAYERS_STATS, payload: core.makeAPICall(params) };
}

export function contestFilterApplyMode(payload) {
  return {
    type: CONTEST_APPLY_FILTER,
    payload: payload,
  };
}
export function contestFilterResetMode() {
  return {
    type: CONTEST_RESET_FILTER,
  };
}
export function contestFilterCloseMode() {
  return {
    type: CONTEST_CLOSE_FILTER,
  };
}
export function contestChangeFilterTabChecks(payload) {
  return {
    type: CONTEST_CHANGE_FILTER_TAB_CHECKES,
    payload: payload,
  };
}
export function contestChangeFilterTab(payload) {
  return {
    type: CONTEST_CHANGE_FILTER_TAB,
    payload: payload,
  };
}
export function myTeamListFetchData(payload) {
  const { LivePntsVrsnNo } = payload;
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sAPI = objUrl.getMyTeamListAPI.replace("{{guid}}", guid);
  let params = {
    url: sAPI,
    params: {
      optType: payload.optType,
      teamgamedayId: payload.teamgamedayId,
      arrtourGamedayId: payload.arrtourGamedayId,
      phaseId: payload.phaseId,
    },
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return {
    type: FETCH_USER_TEAM_LIST,
    payload: core.makeAPICall(params),
    meta: { optType: params.params.optType },
  };
}

export function changeSelectedTeam(payload) {
  return {
    type: CHANGE_SELECTED_TEAM,
    payload: payload,
  };
}

export function getUpcomingFixture(payload) {
  return {
    type: UPCOMING_FIXTURE,
    payload: payload,
  };
}

export function fetchGamerCard(payload) {
  const { VersionMaster } = payload;
  let sAPI = gamerCardAPI.replace("{{guid}}", payload.guid);
  sAPI = sAPI.replace("{{opttype}}", payload.optType);
  sAPI = sAPI.replace("{{platformId}}", payload.platformId);
  sAPI = sAPI.replace("{{clientId}}", payload.clientId);

  const params = {
    url: sAPI,
    params: {},
  };
  if (VersionMaster) {
    params.params.liveVersion = VersionMaster;
  }
  return { type: FETCH_GAMERCARD, payload: core.makeAPICall(params) };
}
export function myTeamListFetchDataOverall(payload) {
  const { LivePntsVrsnNo, cancelToken } = payload;

  const lgApi = app.genrateUrl(payload?.leagueVal);
  let sAPI = objUrl.getMyTeamListOverallAPI.replace("{{leagueVal}}", lgApi);

  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  sAPI = sAPI.replace("{{guid}}", guid);
  let params = {
    url: sAPI,
    params: {
      optType: payload.optType,
      teamgamedayId: payload.teamgamedayId,
      arrtourGamedayId: payload.arrtourGamedayId,
      phaseId: payload.phaseId,
      teamId: payload.teamId,
      SocialId: payload.userId,
    },
  };
  if (cancelToken) {
    params.cancelToken = cancelToken;
  }
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return {
    type: FETCH_USER_TEAM_LIST,
    payload: core.makeAPICall(params),
    meta: { optType: params.params.optType },
  };
}

export function fetchStatsWidget(payload) {
  const { isLive, LivePntsVrsnNo } = payload;
  let sAPI = widgetAPI.replace("{{lang}}", config.CURRENT_LANGUAGE);
  let sLiveAPI = widgetLiveAPI.replace("{{lang}}", config.CURRENT_LANGUAGE);
  let apiName = isLive ? sLiveAPI : sAPI;
  let params = {
    url: apiName,
    params: {},
  };
  if (LivePntsVrsnNo) {
    params.params.liveVersion = LivePntsVrsnNo;
  }
  return { type: FETCH_WIDGET, payload: core.makeAPICall(params) };
}

export function isShowHideMenu(payload) {
  return {
    type: IS_SHOW_MENU,
    payload: payload,
  };
}
export function fetchHeadersData(payload) {
  return {
    type: IS_HEADER_DATA,
    payload: payload,
  };
}

export function fetchUserPlayerStats(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sAPI = userStatsAPI.replace("{{guid}}", guid);
  const params = {
    url: sAPI,
    params: {
      optType: payload.optType,
      teamgamedayId: payload.teamgamedayId,
      arrteamagamedayid: payload.arrteamagamedayid,
      phaseid: payload.phaseid,
    },
  };
  return { type: FETCH_USER_STATS_PLAYER, payload: core.makeAPICall(params) };
}
export function fetchBoostersCon(payload) {
  const { VersionMaster } = payload;

  const params = {
    url: boostersConAPI,
    params: {},
  };
  if (VersionMaster) {
    params.params.liveVersion = VersionMaster;
  }
  return { type: FETCH_BOOSTERS_CONTRAINTS, payload: core.makeAPICall(params) };
}

export function changeSelectedBooster(payload) {
  return {
    type: CHANGE_BOOSTER,
    payload: payload,
  };
}

export function fetchBadges(payload) {
  const { VersionMaster } = payload;

  const params = {
    url: BadgesAPI.replace("{{version}}", VersionMaster),
    params: {},
  };
  return { type: FETCH_BADGES, payload: core.makeAPICall(params) };
}

export function removeLeague(payload) {
  const params = {
    url: removeLeagueAPI,
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_REMOVE_LEAGUE, payload: core.makeAPICall(params) };
}
export function leaveLeague(payload) {
  const params = {
    url: leaveLeagueAPI,
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_REMOVE_LEAGUE, payload: core.makeAPICall(params) };
}

export function updateRemovePlayer(payload) {
  return {
    type: CHANGE_REMOVE_PLAYER,
    payload: payload,
  };
}

export function fetchUserBadges({ optType, BadgeVersion, isBadgeOnly }) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sAPI = (isBadgeOnly ? userbadgemasterAPI : UserBadgesAPI).replace(
    "{{guid}}",
    guid
  );
  const params = {
    url: sAPI,
    params: { optType },
  };
  if (BadgeVersion || BadgeVersion === 0) {
    params.params.badgeVersion = BadgeVersion;
  }
  let type = FETCH_USER_BADGES;
  if (optType === config.enumOptTypeBadge.pointCalulation) {
    type = FETCH_USER_BADGES_AFTER_POINT_CAL;
  }
  return { type: type, payload: core.makeAPICall(params) };
}

export function setWrapperRef(payload) {
  return { type: SET_WRAPPER, payload: payload };
}

// export function saveTeam(payload) {
//   const params = {
//     url: postUserTeamAPI.replace("{{guid}}", payload.GUID),
//     method: "POST",
//     params: {},
//     data: payload,
//   };
//   return { type: POST_SAVE_TEAM, payload: core.makeAPICall(params) };
// }

export function updateBadgeNotify(payload) {
  let sAPI = postBadgeNotifyAPI.replace("{{guid}}", payload.GUID);
  const params = {
    url: sAPI,
    method: "POST",
    params: {},
    data: payload,
  };
  return { type: POST_SAVE_BADGE_NOTIFY, payload: core.makeAPICall(params) };
}

export function UpdateUserBadges(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sAPI = UserBadgesAPI.replace("{{guid}}", guid);
  const params = {};
  return { type: UPDATE_USER_BADGES, payload: payload };
}

export function UpdateUnlockedBadges(payload) {
  const params = {};
  return { type: UPDATE_UNLOCKED_BADGES, payload: payload };
}
export function UpdateUnlockedBadgesTeam(payload) {
  return { type: UPDATE_UNLOCKED_BADGES_TEAM, payload: payload };
}
export function resetStore(payload) {
  return { type: RESET_STORE, payload: payload };
}
export function pullToRefresh(payload) {
  return { type: SHOW_HIDE_PULLTO_REFRESH, payload: payload };
}

export function fetchAkamaiTime() {
  let sAPI = akamaiTimeURL;

  const params = {
    url: sAPI,
    method: "GET",
    params: {},
  };

  return {
    type: AKAMAI_TIMER_CALL,
    payload: Axios.get(sAPI).then(function (response) {
      return response;
    }),
  };
}

// MY PROFILE CHANGES

export function teamNamePostData(payload) {
  // const objCookie = app.getLoginCookie();
  // let guid = objCookie ? objCookie.GUID : "0";
  const param = {
    url: teamNamePostApi,
    method: "POST",
    // params: payload,
    data: payload,
  };
  return { type: POST_TEAM_NAME_SUBMIT, payload: core.makeAPICall(param) };
}

export function fetchCountryFavTeam(payload) {
  const param = {
    url: countryFavStatic,
    method: "GET",
  };
  return { type: FETCH_CTR_FAV_DATA, payload: core.makeAPICall(param) };
}

export function profileUpdatePostData(payload) {
  const param = {
    url: profileUpdatePostApi,
    method: "POST",
    // params: payload,
    data: payload,
  };
  return { type: POST_PROFILE_UPDATE_SUBMIT, payload: core.makeAPICall(param) };
}

export function fetchProfileData(payload) {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";

  const param = {
    url: profileGetApi.replace("{{guid}}", guid),
    method: "GET",
    params: { optType: 1 },
  };
  return { type: FETCH_PROFILE_DATA, payload: core.makeAPICall(param) };
}

export function shouldDeleteBooster(payload) {
  return {
    type: SHOULD_DELETE_BOOSTER,
    payload: payload,
  };
}

export function fetchConfigData(payload) {
  const { VersionMaster } = payload;
  const param = {
    url: configApi.replace("{{version}}", VersionMaster),
    method: "GET",
  };
  return { type: FETCH_CONFIG_DATA, payload: core.makeAPICall(param) };
}

export function fetchUserPointsHistory() {
  const objCookie = app.getLoginCookie();
  let guid = objCookie ? objCookie.GUID : "0";
  let sUrl = userPtsHistory.replace("{{guid}}", guid);
  sUrl = sUrl.replace("{{opttype}}", 1);
  const param = {
    url: sUrl,
    optType: 1,
    method: "GET",
  };
  return { type: FETCH_USER_POINTS_HISTORY, payload: core.makeAPICall(param) };
}

export function resetBooster(payload) {
  return {
    type: BOOSTER_RESET,
    payload: payload,
  };
}
